class ShpfltHtmlElement extends HTMLElement {
	flickity = null;
  constructor() {
    super();
  }
  async init() {
    const { Flickity } = await import(flu.chunks.flickity);
    this.flickity = Flickity;
  }
}

class ShpfltProductItem extends ShpfltHtmlElement {
  slider = null;
  constructor() {
    super();
    this.productHandle = this.getAttribute("data-product-handle");
    this.sliderElement = this.querySelector(".slider");
    if (!this.sliderElement) return;
    this.prevArrow = this.querySelector(".product-item__prev");
    this.nextArrow = this.querySelector(".product-item__next");
    this.pageDots = this.getAttribute("data-page-dots") === "false" ? false : true;
    this.init().then(() => {
      this.initObservers();
    });
  }
  initObservers() {
    // observe when the slider is into the viewport (40px of threshold)
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.initSlider();
          }
        });
      },
      {
        rootMargin: "200px",
      }
    );
    observer.observe(this);
  }
  initSlider() {
    this.slider = new this.flickity(this.sliderElement, {
      prevNextButtons: this.prevArrow && this.nextArrow,
      pageDots: this.pageDots,
      lazyLoad: 2,
      wrapAround: true
    });
  }
}

document.addEventListener("DOMContentLoaded", () => { 
  if (!customElements.get("shpflt-product-item")) {
    customElements.define("shpflt-product-item", ShpfltProductItem);
  }
});
